module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'documents',
		'table',
		'table'
	],

	config: {
		// inline: false
	},

	methods: {

		onPrepareDone: function(storage){
			this.resourceData.data = ((storage.request || {}).documentData || {}).data || []
			this.resourceData.initialized = false;
			this.sanitizeResources(storage)
		},

		// sanitizeResourceFilters: function(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
		// 	// override sanitizeResourceFilters of extended component only!
		// },

		sanitizeEntity: function(refEntity){
			if((refEntity.attributes || {}).idx === 1){
				refEntity.meta = refEntity.meta || {}
				refEntity.meta.hasGroupRow = true
			}
		},

		showEdit: function(rowID, rowData, buttonMode){
			// prevent actions in this table
		},
	},
}